export const AMO_STATUS = "AMO_STATUS";
export const AMO_STATUS_ERROR_DATA = "AMO_STATUS_ERROR_DATA";
export const AMO_STATUS_HIDE_ERROR_DATA = "AMO_STATUS_HIDE_ERROR_DATA";
export const AMO_STATUS_START_LOADER = "AMO_STATUS_START_LOADER";
export const AMO_STATUS_STOP_LOADER = "AMO_STATUS_STOP_LOADER";
